import React, { SelectHTMLAttributes, useEffect, useRef } from 'react';

// @ts-ignore: side-effect import for SCSS style sheet
import './style.scss';



// Define the shape of a single option
interface DropdownOption {
  value: string | number;
  label: string;
}

// Extend standard HTML select attributes to keep the component flexible
interface DropdownProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options?: DropdownOption[] | undefined;
  placeholder?: string;
  setCount: React.Dispatch<React.SetStateAction<string>>;
}

export const Dropdown: React.FC<DropdownProps> = ({
  options,
  placeholder = 'Select an option...',
  className = '',
  value,
  setCount
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const [updateablePlaceholder, setUpdateablePlaceholder] = React.useState<string>(placeholder);
  const [selectedText, setSelectedText] = React.useState<string>("");
  const [filteredOptions, setFilteredOptions] = React.useState<DropdownOption[] | undefined>(options);


  useEffect(() => {

    if (selectedText !== "")
      setFilteredOptions(options?.filter(option => option.label.toLowerCase().includes(selectedText.toLowerCase())));
    else
      setFilteredOptions(options);

  }, [options]);


  return (<>
    <div className='mb-3'>{value}</div>
    <div className='mb-3'>{selectedText}</div>
    <div className='dropdown-container'>
      <input className='form-select' placeholder={updateablePlaceholder} onChange={(e) => setSelectedText(e.currentTarget.value)} />
      <div id="options" className='options'>
        {filteredOptions?.map((option) => (
          <div key={option.value} ref={containerRef} data-value={option.value} onMouseDown={(e) => {
            setUpdateablePlaceholder(option.label);
            setCount(e.currentTarget.getAttribute('data-value') || '');

            if (containerRef.current) {
              containerRef.current.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth' // Use 'auto' for an instant jump instead of an animation
              });
            }
          }} className='option'>
            {option.label}
          </div >
        ))}
      </div>
    </div >


    {/* <select
      className={`custom-dropdown ${className}`}
      value={value}
      onChange={(e) => setCount(e.target.value)}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options?.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select> */}

  </>
  );
};
